import React from "react";
import PropTypes from "prop-types";
import Image from "components/Image";
import { BRAND_LOGO_VARIANTS } from "constants/brands";
import { gradients } from "style";
import { MarketingLogo, TalentSimpleWordmark } from "components/Logo";
import TalentSimpleIcon from "assets/images/TalentSimpleIcon.svg";
import TalentSimpleIconBlack from "assets/images/TalentSimpleIconBlack.svg";

/**
 * TalentSimpleLogo
 *
 * @param {String}   variant   One of BRAND_LOGO_VARIANTS: the wordmark, the icon, or the marketing mark
 * @param {String}   fill      Wordmark color
 * @param {String}   alt
 */
const TalentSimpleLogo = ({ variant = BRAND_LOGO_VARIANTS.wordmark, fill, alt, ...props }) => {
  if (variant === BRAND_LOGO_VARIANTS.icon) {
    return <Image url={TalentSimpleIcon} alt={alt} {...props} />;
  }

  if (variant === BRAND_LOGO_VARIANTS.marketing) {
    return (
      <MarketingLogo
        icon={TalentSimpleIconBlack}
        hoverBackground={gradients.talentSimpleGradient}
        width="2.8rem"
        role="img"
        aria-label={alt}
        {...props}
      />
    );
  }

  return <TalentSimpleWordmark fill={fill} aria-label={alt} {...props} />;
};

TalentSimpleLogo.propTypes = {
  variant: PropTypes.oneOf(Object.values(BRAND_LOGO_VARIANTS)),
  fill: PropTypes.string,
  alt: PropTypes.string,
};

export default TalentSimpleLogo;
